import { Record } from 'immutable';
import moment from 'moment-timezone';

export default class Address extends Record({
  address1: null,
  address2: null,
  city: null,
  state: null,
  postalCode: null,
  country: null,
  coordinates: null,
  timezone: moment.tz.guess(),
  types: [],
}) {
  constructor(props) {
    if (!props) {
      super();
      return;
    }

    super({
      address1: props.address1,
      address2: props.address2,
      city: props.city,
      state: props.state,
      postalCode: props.postal_code,
      country: props.country,
      coordinates: props.coordinates ? { lat: props.coordinates[0], lng: props.coordinates[1] } : null,
      timezone: props.timezone || moment.tz.guess(),
      types: props.types || [],
    });
  }
}
